export default "__VITE_ASSET__XxkzdB4m__"